import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

import banner4 from "../assets/beans.jpg";
import banner5 from "../assets/hero.JPG";
import banner6 from "../assets/kili.jpg";
import banner7 from "../assets/ZANZIBAR5.jpg";
import safari from "../assets/pumas.jpg";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);

  const slides = useMemo(
    () => [
      {
        image: safari,
        word: "Safari into Tanzania's Wildlife Wonders",
        buttonLabel: "Explore Safaris",
        action: () => appContext.navTo({ item: "services", subItem: "safaris" }),
      },
      {
        image: banner6,
        word: "Summit Africa's Highest Peak on Mount Kilimanjaro",
        buttonLabel: "View Kilimanjaro Routes",
        action: () => appContext.navTo({ item: "services", subItem: "treks" }),
      },
      {
        image: banner7,
        word: "Relax Along the Pristine Shores of Zanzibar",
        buttonLabel: "Discover Zanzibar",
        action: () => appContext.navTo({ item: "services", subItem: "zanzibar" }),
      },
      {
        image: banner4,
        word: "Connect With Experts to Plan Your Perfect Journey",
        buttonLabel: "Plan With Us",
        action: () => appContext.navTo({ item: "contact_us" }),
      },
    ],
    [appContext]
  );

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slides.length);
    }, 4600);
    return () => clearInterval(interval);
  }, [ready, slides.length]);

  if (!ready) {
    return <div style={{ padding: 40 }}>{getInlineLoader()}</div>;
  }

  return (
    <section
      style={{
        position: "relative",
        height: "calc(100vh - var(--topBarHeight))",
        minHeight: 620,
        width: "100%",
        overflow: "hidden",
      }}
    >
      <span className="kwetu-orb kwetu-orb-a" />
      <span className="kwetu-orb kwetu-orb-b" />

      <div
        style={{
          display: "flex",
          width: `${slides.length * 100}%`,
          height: "100%",
          transform: `translateX(-${(100 / slides.length) * slideIndex}%)`,
          transition: "transform 900ms ease-in-out",
        }}
      >
        {slides.map((slide) => (
          <article
            key={slide.title}
            style={{
              width: `${100 / slides.length}%`,
              height: "100%",
              position: "relative",
              flex: `0 0 ${100 / slides.length}%`,
              backgroundImage: `url(${slide.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(132deg, rgba(5,22,22,0.55) 0%, rgba(11, 39, 33, 0.55) 45%, rgba(7,21,37,0.45) 100%)",
              }}
            />

            <div
              data-aos="zoom-in"
              style={{
                position: "relative",
                zIndex: 1,
                width: "100%",
                height: "100%",
                padding: "24px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                color: "#fff",
              }}
            >
              <div style={{ width: "100%" }}>
                <div className="kwetu-slide-stack">
                  <h1 className="kwetu-slide-word font-bold">{slide.word}</h1>
                  <button
                    onClick={slide.action}
                    className="hero-cta hero-cta-primary font-semi-bold"
                  >
                    {slide.buttonLabel} 
                  </button>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>

    </section>
  );
}
